import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {COMPONENT_STATES} from "../../../core/consts";
import {StandingsWidgetController} from "../standings-widget.controller";
import {StandingsWidgetState} from "../models/standings-widget.state";
import {STANDINGS_WIDGET} from "../standings-widget.consts";

export class StandingsWidgetCompetitionChangeHandler extends ActionHandler {
  controller: StandingsWidgetController;
  state: StandingsWidgetState;
  type = STANDINGS_WIDGET.ACTION_TYPES.competitionChange;

  async action(params) {
    if(params) {
      this.store.setComponentState(COMPONENT_STATES.loading);
      this.state.selectedCompetitionId = params.competitionId;
      this.state.selectedSeasonNum = null;
      this.state.currentStageNum = null;

      await this.controller.action(STANDINGS_WIDGET.ACTION_TYPES.onStageChange, {});

      this.store.setComponentState(COMPONENT_STATES.loaded);
    }
  }

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const competitorIdChanged: Boolean = prevProps.competitorId !== nextProps.competitorId;

    if(competitorIdChanged) {
      this.state.selectedCompetitionId = null;
    }
  }
}
